import { Col, Row, Card } from 'antd'
import styled from 'styled-components'

import bg from '../../Assets/Images/login_bg.png'
import bg_box from '../../Assets/Images/login_bg_box.png'

export const LayoutBackground = styled(Row)`
  height: 100vh;
  width: 100%;
  background-image: url(${bg});
  background-position: center bottom;
  background-size: cover;
`

export const Container = styled(Card)`
  height: 455px;
  width: 1000px;
  border: 0;
  .ant-card-body {
    padding: 0;
  }
  .ant-card-body > .ant-row {
    height: 454px;
  }
`

export const ColLeft = styled(Col)`
  background-image: url(${bg_box});
  background-position: left center;
  background-size: cover;
`

export const ColRight = styled(Col)`
  background: #202225;
  padding: 60px 90px;
`
